import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import TermSheetPageUI from './TermSheetPageUI.js'

class TermSheetPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      directorList: null,
      propertyList: null,
      termsList: [],
      apr: null,
      aprFormula: null,
      receivableFinancingLimitUpdateMode: false,
      minMonthlyCollectionAmountUpdateMode: false,
      termsUpdateMode: false,
      dsraReleaseMode: false,
    }
  }

  render() {
    return (
      <TermSheetPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        apr={this.state.apr}
        aprFormula={this.state.aprFormula}
        directorList={this.state.directorList}
        propertyList={this.state.propertyList}
        onRefreshClick={this.onRefreshClick}
        termsList={this.state.termsList}
        //
        receivableFinancingLimitUpdateMode={this.state.receivableFinancingLimitUpdateMode}
        onSetReceivableFinancingLimitClick={() => { (this.setState({ receivableFinancingLimitUpdateMode: true })) }}
        onSetReceivableFinancingLimitCancel={() => { (this.setState({ receivableFinancingLimitUpdateMode: false })) }}
        //
        minMonthlyCollectionAmountUpdateMode={this.state.minMonthlyCollectionAmountUpdateMode}
        onSetMinMonthlyCollectionAmountClick={() => { (this.setState({ minMonthlyCollectionAmountUpdateMode: true })) }}
        onSetMinMonthlyCollectionAmountCancel={() => { (this.setState({ minMonthlyCollectionAmountUpdateMode: false })) }}
        //
        termsUpdateMode={this.state.termsUpdateMode}
        onTermsUpdateClick={() => { this.setState({ termsUpdateMode: true }) }}
        onTermsUpdateCancel={() => { this.setState({ termsUpdateMode: false }) }}
        //
        //
        dsraReleaseMode={this.state.dsraReleaseMode}
        onDsraReleaseClick={() => { this.setState({ dsraReleaseMode: true }) }}
        onDsraReleaseCancel={() => { this.setState({ dsraReleaseMode: false }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
    this.getDirectors(context)
    this.getProperties(context)
    this.getApr(context)
    this.getLoanTerms(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    let context = this.props.context
    this.setState({ errorList: response.errorList, loan: response.loan })
  }

  getDirectors(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/users`,
      cacheKey: CacheKeys.LoanDirectors(this.props.match.params.loanId),
      callback: this.getDirectorsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getDirectorsCallback = (response) => {
    this.setState({ errorList: response.errorList, directorList: response.accountUserList })
  }

  getLoanTerms(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/termList`,
      cacheKey: CacheKeys.LoanTerms(this.props.match.params.loanId),
      callback: this.getLoanTermsCallback,
      ttlInSecs: 3600,
    });
    cacheManager.getObject2(context);
  }

  getLoanTermsCallback = (response) => {
    this.setState({
      termsList: response.termsList,
      errorList: response.errorList,
    });
  };

  getProperties(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/properties`,
      cacheKey: CacheKeys.LoanProperties(this.props.match.params.loanId),
      callback: this.getPropertiesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getPropertiesCallback = (response) => {
    this.setState({ errorList: response.errorList, propertyList: response.loanPropertyList })
  }

  getApr(context) {
    let cacheManager = new CacheManager({
      resource: `/api/loans/${this.props.match.params.loanId}/apr`,
      cacheKey: CacheKeys.LoanApr(this.props.match.params.loanId),
      callback: this.getAprCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAprCallback = (response) => {
    this.setState({ errorList: response.errorList, apr: response.apr, aprFormula: response.formula })
  }

  onRefreshClick = (noBusy) => {
    let loan = this.state.loan
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Loan(loan.loanId))
    CacheManager.removeObject(CacheKeys.LoanDirectors(loan.loanId))
    CacheManager.removeObject(CacheKeys.LoanTerms(this.props.loanId));
    CacheManager.removeObject(CacheKeys.LoanProperties(loan.loanId))
    CacheManager.removeObject(CacheKeys.LoanApr(loan.loanId))
    if (noBusy === 'noBusy') {
      this.getLoan(context)
      this.getDirectors(context)
      this.getApr(context)
    }
    else {
      this.setState({
        loan: null,
        errorList: null,
      })
      this.getLoan(context)
      this.getDirectors(context)
      this.getLoanTerms(context)
      this.getProperties(context)
      this.getApr(context)
    }
  }
}

export default withRouter(TermSheetPageSF)
